import * as mutates from "../mutations.js"
import * as actions from "../actions.js"
import composition from "../type/item/composition.js"
import defaultPage from "../defaultPage.js"
import defaultCompositions from "../defaultCompositions.js"
import defaultRessource from "../type/definition/defaultRessource.js"
import userApi from "../../api/user.js"
import compositionApi from "../../api/composition.js"
import themeApi from "../../api/theme.js"
import { useRoute } from 'vue-router'
import * as NAMESPACES from "../namespaceStore.js"

export default {
    namespaced: true,
    state: {
        eventCompositionSet: new Event("composition-set"),
        eventCompositionAdd: new Event("composition-add"),
        eventCompositionRemove: new Event("composition-remove"),
        editorType: "Classic_T_",
        themeName: null,
        themeId: null,
        themeDescription: null,
        themeThumbnail: null,
        themeList: [],
        themeModificationNotSaved: false,
        ressources: [],
        fontPromiseList: [],
        compositions: [],
        compositionEditing: null,
        possibleCompositions: [],
        currentCompositionIndex: null,
        pages: {},
        currentElementIndex: null,
        currentPageIndex: null,
        waitingToAdd: undefined,
        addedAction: undefined,
        history: [],
        historyIndex: 0,
        isDarkMode: false,
        snapEnabled: true,
        dragData: {
            element: null,
            type: "",
            direction: null,
            X: 0,
            Y: 0,
        },
        snapData: {
            enabled: true,
            threshold: 10,
            snap: {
                horizontal: [],
                vertical: []
            },
            guide: {
                horizontal: [],
                vertical: []
            }
        },
        previewScale: 1,
        previewScaleComposition: 1,
        usedScale: 1,
        copiedElement: null,
    },
    getters: {
        copiedElement: state => { return state.copiedElement },
        themeBuild: state => {
            return state.themeList.find(theme => theme.id == state.themeId)?.url_fichier_build;
        },
        themeModificationNotSaved: state => { return state.themeModificationNotSaved },
        themeName: state => { return state.themeName },
        themeId: state => { return state.themeId },
        themeList: state => { return state.themeList },
        themeDescription: state => { return state.themeDescription },
        themeThumbnail: state => { return state.themeThumbnail },
        themeThumbnailPath: state => { return state.ressources.find(r => r.id == state.themeThumbnail)?.url },
        fontPromiseList: state => { return state.fontPromiseList },
        compositionEditing: state => { return state.compositionEditing },
        compositionById: state => { return (id) => { return state.possibleCompositions.find(c => c.id == id) } },
        compositionByPreviewId: state => { return (previewId) => { return state.possibleCompositions.find(c => c.previewId == previewId) } },
        compositionBySiteID: state => { return (siteId) => { return state.possibleCompositions.find(c => c.siteId == siteId) } },
        previewScale: state => { return state.previewScale },
        previewScaleComposition: state => { return state.previewScaleComposition },
        getPageElementPossible: state => {
            if (state.currentPageIndex == null || state.pages[state.currentPageIndex] == null) {
                return [];
            }
            return state.pages[state.currentPageIndex].getPropertiesDescription().filter((el) => {
                if (el.jsType == "Array") {
                    if (el.maxElement !== undefined) {
                        return state.pages[state.currentPageIndex][el.name].length < el.maxElement;
                    }
                    else {
                        return true;
                    }
                }
                if (!state.pages[state.currentPageIndex][el.name]) return true;
                return false;
            });
        },
        addedAction: state => { return state.addedAction },
        compositions: state => {return state.compositions},
        currentCompositionIndex: state => {return state.currentCompositionIndex},
        currentComposition: state => { return state.compositions[state.currentCompositionIndex] },
        possibleCompositions: (state) => { 
            return state.possibleCompositions
        },
        compositionsElement: (state) => (property) => {
            let element = [];
            state.compositions.forEach(c => {
                if (Array.isArray(c[property]))
                    element.push(...c[property]);
                else
                    element.push(c[property]);
            });
            return element;
        },
        ressources: state => { return state.ressources },
        ressourcesByType: (state) => (type) => {
            return state.ressources.filter(ressource => ressource.type_ressource == type);
        },
        firstRessourceByType: (state) => (type) => {
            let ressource = state.ressources.find(ressource => ressource.type_ressource == type);
            if (ressource == null) {
                ressource = defaultRessource[type];
            }
            return ressource;
        },
        getRessource: (state) => (ressource) => {
            return state.ressources.find(r => r.path == ressource || r.name == ressource || r.url == ressource);
        },
        ressourceByIDSoft: (state) => (idSoft) => {
            return state.ressources.find(ressource => ressource.idSoft == idSoft);
        },
        ressourceByName: (state) => (name) => {
            return state.ressources.find(ressource => ressource.name == name);
        },
        ressourceByPath: (state) => (path) => {
            return state.ressources.find(ressource => ressource.url == path);
        },
        hasCurrentTheme: state => { return Object.keys(state.pages).length > 0 },
        pages: state => { return state.pages },
        pagesArray: state => { return Object.entries(state.pages) },
        getCurrentCompositionElement: (state) => {
            if (state.currentElementIndex == null || state.compositionEditing == null) {
                return null;
            }
            return state.compositionEditing.getCompositionElementById(state.currentElementIndex);
        },
        getCompositionElementById: (state) => (id) => {
            if (state.compositionEditing == null || id == null) {
                return null;
            }
            return state.compositionEditing.getCompositionElementById(id);
        },
        getBaseElementById: (state) => (id) => {
            if (state.currentPageIndex == null || id == null || state.pages[state.currentPageIndex] == null) {
                return null;
            }
            let pagesElements = state.pages[state.currentPageIndex]?.toIterable();
            if (pagesElements == null) {
                return null;
            }
            for (const element of pagesElements) {
                let result = element.getBaseElementById(id);
                if (result != null && typeof result == "object" && result.isBaseElement == true) {
                    return result;
                }
            }
            return null;
        },
        getElementByPreviewId: (state) => (previewId) => {
            if (state.currentPageIndex == null || state.pages[state.currentPageIndex] == null) {
                return null;
            }
            let pagesElements = state.pages[state.currentPageIndex]?.toIterable();
            if (pagesElements == null || pagesElements.length == 0) {
                return null;
            }
            for (const page of pagesElements) {
                let element = page.getFromPreviewId(previewId);
                if (element != null) {
                    return element;
                }
            }
            return null;
        },
        currentElement: state => {
            if (state.currentPageIndex == null || state.currentElementIndex == null || state.pages[state.currentPageIndex] == null) {
                return null;
            }
            let pagesElements = state.pages[state.currentPageIndex]?.toIterable();
            if (pagesElements == null || pagesElements.length == 0) {
                return null;
            }
            for (const element of pagesElements) {
                let elementFound = element.getFromPreviewId(state.currentElementIndex);
                if (elementFound != null) {
                    return elementFound;
                }
            }
            return null
        },
        currentElementIndex: state => { return state.currentElementIndex },
        currentPage: state => { return state.pages[state.currentPageIndex] },
        currentPageIndex: state => { return state.currentPageIndex },
        history: state => { return state.history },
        historyIndex: state => { return state.historyIndex },
        canUndo: state => { return state.historyIndex > 0 },
        canRedo: state => { return state.historyIndex < state.history.length - 1 },
        isDarkMode: state => { return state.isDarkMode },
        snapEnabled: state => { return state.snapEnabled },
        previewIsVisible: state => { return state.previewIsVisible },
        dragData: state => { return state.dragData },
        snapData: state => { return state.snapData },
        themeJson: state => { 
            let theme = {}
            Object.keys(state.pages).forEach(pageIndex => {
                theme[pageIndex] = state.pages[pageIndex].toObject(true);
            });
            return theme;
        },
        checkThemeIsComplete: state => {
            let result = {isComplete: true, requiredBeforeSave: false, missingElements: []};
            Object.keys(state.pages).forEach(pageIndex => {
                result = state.pages[pageIndex].checkIsComplete(result);
            });
            return result;
        },
        exportTheme: state => {
            let themePackage = {
                theme_config: {
                    Version: "1.0.0",
                    Id: state.themeId,
                    Name: state.themeName,
                    Description: state.themeName,
                    SoftwareName: "Liview-app",
                    SoftwareVersion: "1.0.*",
                    App: "Classic",
                    Thumbnail: state.themeThumbnail ? state.themeThumbnail : 0,
                    Templates: [],
                    Ressources: [],
                    Variables: [],
                },
                configs: [],
            };
            Object.keys(state.pages).forEach(pageIndex => {
                let page = state.pages[pageIndex];
                themePackage.theme_config.Variables = page.getVariables(themePackage.theme_config.Variables);
                themePackage.theme_config.Ressources = page.getRessources(themePackage.theme_config.Ressources);
                themePackage.theme_config.Templates.push({
                    Type: state.editorType + pageIndex,
                    Path: pageIndex + ".yaml"
                });
                themePackage.configs.push({
                    fileName: pageIndex + ".yaml",
                    type: state.editorType + pageIndex,
                    data: page.toExportObject(themePackage.theme_config.Variables, themePackage.theme_config.Ressources)
                });
            });
            let compositionIndex = themePackage.configs.push({
                fileName: "compositions.yaml",
                data: [],
                type: state.editorType + "Compositions"
            }) - 1;
            themePackage.theme_config.Templates.push({
                Type: state.editorType + "Compositions",
                Path: "compositions.yaml"
            });
            let compositionData = {
                compositions: [],
            };
            state.compositions.forEach(composition => {
                themePackage.theme_config.Variables = composition.getVariables(themePackage.theme_config.Variables);
                themePackage.theme_config.Ressources = composition.getRessources(themePackage.theme_config.Ressources);
                compositionData.compositions.push(composition.toExportObject(themePackage.theme_config.Variables, themePackage.theme_config.Ressources));
            });
            themePackage.configs[compositionIndex].data = compositionData;
            return themePackage;
        }
    },
    mutations: {
        [mutates.DEFAULT](state) {
            Object.values(state.pages).forEach(page => {
                state.pages[page].dispose();
                delete state.pages[page];
            });
            delete state.pages;
            state.pages = {};
            state.compositions = [];
            state.possibleCompositions = [];
            state.copiedElement = null;
            state.compositionEditing = null;
            state.themeList = [];
            state.ressources = [];
            state.themeId = null;
            state.themeThumbnail = null;
            state.themeName = "";
            state.themeDescription = "";
            state.themeModificationNotSaved = false;
            state.currentElementIndex = null;
            state.currentPageIndex = null;
            state.history = [];
            state.historyIndex = 0;
            state.selectedElement = null;
            state.addedAction = undefined;
        },
        [mutates.PASTE_COPIED_ELEMENT](state) {
            if (state.currentPageIndex == null || state.currentElementIndex == null || state.pages[state.currentPageIndex] == null) {
                return;
            }
            let pagesElements = state.pages[state.currentPageIndex]?.toIterable();
            if (pagesElements == null || pagesElements.length == 0) {
                return;
            }
            for (const element of pagesElements) {
                let elementFound = element.getFromPreviewId(state.currentElementIndex);
                if (elementFound != null) {
                    elementFound.objectToClassValue(state.copiedElement.toObject(true), true);
                    state.currentElementIndex = elementFound.previewId;
                    return;
                }
            }
        },
        [mutates.SET_COPIED_ELEMENT](state, element) {
            state.copiedElement = element;
        },
        [mutates.SET_USED_SCALE](state, usedScale) {
            state.usedScale = usedScale;
        },
        [mutates.SET_THEME_MODIFICATION_NOT_SAVED](state, modificationNotSaved) {
            state.themeModificationNotSaved = modificationNotSaved;
        },
        [mutates.SELECT_THEME](state, index) {
            if (state.themeList.length > 0 && index != null && index >= 0 && index < state.themeList.length) {
                state.history = [];
                state.historyIndex = 0;
                state.themeId = state.themeList[index].id;
                state.themeThumbnail = state.themeList[index].fichier_thumbnail?.id;
                state.themeName = state.themeList[index].nom;
                state.themeDescription = state.themeList[index].description;
                state.pages = {};
                Object.entries(state.themeList[index].theme).forEach(([key, value]) => {
                    state.pages[key] = defaultPage[key].constructor.fromObject(JSON.parse(JSON.stringify(value)));
                });
                state.currentPageIndex = Object.keys(state.pages)[0];
            }
            else {
                state.history = [];
                state.historyIndex = 0;
                state.themeId = null;
                state.themeThumbnail = null;
                state.themeName = "";
                state.themeDescription = "";
                state.pages = {};
                state.currentPageIndex = null;
                Object.entries(defaultPage).forEach(([key, page]) => {
                    state.pages[key] = page.constructor.fromObject({});
                });
                state.currentPageIndex = Object.keys(state.pages)[0];
            }
            state.themeModificationNotSaved = false;
            state.copiedElement = null;
        },
        [mutates.SET_THEME_THUMBNAIL](state, thumbnail) {
            state.themeThumbnail = thumbnail;
        },
        [mutates.SET_THEME_LIST](state, theme) {
            let index = state.themeList.findIndex(t => t.id == theme.id);
            if (index != -1) {
                state.themeList[index] = theme;
            }
            else {
                state.themeList.push(theme);
            }
        },
        [mutates.SET_THEME_ID](state, id) {
            state.themeId = id;
        },
        [mutates.SET_THEME_NAME](state, name) {
            state.themeName = name;
        },
        [mutates.SET_THEME_DESCRIPTION](state, description) {   
            state.themeDescription = description;
        },
        [mutates.CLEAR_FONT_PROMISE_LIST](state) {
            state.fontPromiseList = [];
        },
        [mutates.LOAD_FONT](state, payload) {
            let font = state.ressources.find(r => r.idSoft == payload.ressource.idSoft);
            font.fontLoaded = true;
            state.fontPromiseList.push(payload.font.then((result) => {
                document.fonts.add(result);
            }).catch(error => {
                font.fontLoaded = false;
            }));
        },
        [mutates.SET_COMPOSITION_EDITING](state, composition) {
            state.compositionEditing = composition;
        },
        [mutates.SET_ACTIVE_COMPOSITION_FROM_THEME](state) {
            state.compositions = [];
            Object.values(state.pages).forEach(page => {
                let pagesElements = page?.toIterable();
                if (pagesElements == null) {
                    return null;
                }
                for (const element of pagesElements) {
                    let result = element.getElementBy("id", "COMPOSITION_SELECTION_GRID");
                    if (result != null && result._Contents && result._Contents.length > 0) {
                        result._Contents.forEach((el, index) => {
                            const c = state.possibleCompositions.find(c => c.previewId == el);
                            if (c != null) {
                                state.compositions.push(c);
                            }
                            else {
                                result._Contents.splice(index, 1);
                            }
                        });
                        return;
                    }
                }
            });
        },
        [mutates.SET_COMPOSITIONS](state, compositions) {
            state.compositions = compositions.map(c => c.heavyClone());
            document.dispatchEvent(state.eventCompositionSet);
        },
        [mutates.ADD_COMPOSITION](state, composition) {
            let index = state.possibleCompositions.findIndex(c => c.siteId == composition.siteId);
            if (index != -1) {
                state.possibleCompositions[index] = composition;
            }
            else {
                state.possibleCompositions.push(composition);
            }
            index = state.compositions.findIndex(c => c.siteId == composition.siteId);
            if (index != -1) {
                state.compositions[index] = composition;
            }
            document.dispatchEvent(state.eventCompositionAdd);
        },
        [mutates.CREATE_COMPOSITION](state) {
            state.currentCompositionIndex = state.compositions.push(composition.fromObject()) - 1;
        },
        [mutates.REMOVE_SHURTCUT_ACTION](state) {
            state.addedAction = undefined;
        },
        [mutates.UNSELECT_ELEMENT](state) {
            state.currentElementIndex = null;
            state.dragData.element = null;
            state.dragData.type = "";
            state.dragData.direction = null;
            state.dragData.X = 0;
            state.dragData.Y = 0;
        },
        [mutates.ADD_ELEMENT](state, payload) {
            if (payload.element == null) {
                if (payload.target == "CompositionElement") {
                    state.compositions.push(payload.toAdd);
                    state.currentElementIndex = state.pages[state.currentPageIndex].CompositionPreviewId(payload.toAdd);
                    return;
                }
                else if (state.currentPageIndex == null || state.pages[state.currentPageIndex] == null) {
                    return null;
                }
                else if (Array.isArray(state.pages[state.currentPageIndex][payload.target])) {
                    if (Array.isArray(payload.toAdd)) {
                        Array.prototype.push.apply(state.pages[state.currentPageIndex][payload.target], payload.toAdd);
                    }
                    else {
                        state.pages[state.currentPageIndex][payload.target].push(payload.toAdd);
                    }
                }
                else {
                    state.pages[state.currentPageIndex][payload.target] = payload.toAdd;
                }
                state.currentElementIndex = payload.toAdd.previewId;
            }
            else {
                if (Array.isArray(payload.element[payload.target])) {
                    payload.element[payload.target].push(payload.toAdd);
                }
                else {
                    payload.element[payload.target] = payload.toAdd;
                }
            }
            state.addedAction = payload.toAdd;
        },
        [mutates.ADD_COMPOSITION_ELEMENT](state, payload) {
            state.compositionEditing.addToBuild(payload);
            state.currentElementIndex = payload.previewId;
            state.addedAction = payload;
        },
        [mutates.SET_PREVIEW_SCALE](state, previewScale) {
            state.previewScale = previewScale;
        },
        [mutates.SET_PREVIEW_SCALE_COMPOSITION](state, previewScale) {
            state.previewScaleComposition = previewScale;
        },
        [mutates.CREATE_DEFAULT_COMPOSITION](state) {
            if (defaultCompositions.length > 0) {
                state.compositions = defaultCompositions.map(c => composition.fromObject(c).heavyClone());
            }
            else {
                state.compositions = [];
            }
        },
        [mutates.UPDATE_POSSIBLE_COMPOSITIONS_THUMBNAIL](state, payload) {
            let index = state.possibleCompositions.findIndex(c => c.Thumbnail.id == payload.id);
            if (index != -1 && state.possibleCompositions[index].Thumbnail) {
                state.possibleCompositions[index].Thumbnail.Path = payload.Path;
            }
        },
        [mutates.SAVE_COMPOSITION_EDIT](state) {
            if (state.compositionEditing) {
                let index = state.compositions.findIndex(c => c.previewId == state.compositionEditing.previewId);
                if (index != -1) {
                    state.compositions[index] = state.compositionEditing.heavyClone();
                }
                else if (state.compositions.length == 0) {
                    state.compositions.push(state.compositionEditing.heavyClone());
                }
                index = state.possibleCompositions.findIndex(c => c.previewId == state.compositionEditing.previewId);
                if (index != -1) {
                    state.possibleCompositions[index] = state.compositionEditing.heavyClone();
                }
                else {
                    state.possibleCompositions.push(state.compositionEditing.heavyClone());
                }
            }
        },
        [mutates.CREATE_DEFAULT_THEME](state) {
            let dc = defaultCompositions.map(c => composition.fromObject(c));
            // state.pages = {...defaultPage};
            state.possibleCompositions.push(...dc);
            if (state.compositions.length == 0 && state.possibleCompositions.length > 0) {
                state.compositions.push(state.possibleCompositions[0]);
            }
            // state.currentPageIndex = Object.keys(defaultPage)[0];
            state.history = [];
            state.historyIndex = 0;
        },
        [mutates.UPDATE_SNAP_GUIDELINES](state, snapGuidelines) {
            const horizontalLines = []
            const verticalLines = []

            snapGuidelines.forEach(element => {
                // Lignes horizontales
                horizontalLines.add(element.y)
                horizontalLines.add(element.y + element.height)

                // Lignes verticales
                verticalLines.add(element.x)
                verticalLines.add(element.x + element.width)
            })

            state.snapData.snap = {
                horizontal: Array.from(horizontalLines),
                vertical: Array.from(verticalLines)
            }
        },
        [mutates.ADD_TO_HISTORY](state, needToWait) {
            const action = () => {
                const maxLength = 20;
                if (state.historyIndex < state.history.length - 1) {
                    state.history = state.history.slice(0, state.historyIndex + 1)
                }
                state.historyIndex = state.history.push({
                    currentElementIndex: state.currentElementIndex,
                    pageIndex: state.currentPageIndex,
                    data: state.currentPageIndex ? JSON.stringify(state.pages[state.currentPageIndex].toObject()) : null,
                    compositions: state.compositions.map((el) => JSON.stringify(el.toObject())),
                    compositionEditing: state.compositionEditing ? JSON.stringify(state.compositionEditing.toObject()) : null,
                }) - 1;
                if (state.history.length > maxLength) {
                    state.history = state.history.splice(state.history.length - maxLength, state.history.length - (state.history.length - maxLength));
                    state.historyIndex = state.history.length - 1;
                }
            }
            if (state.waitingToAdd) {
                clearTimeout(state.waitingToAdd);
            }
            if (needToWait) {
                state.waitingToAdd = setTimeout(action, 750);
            }
            else {
                action();
            }
        },
        [mutates.START_RESIZE](state, payload) {
            state.currentElementIndex = payload.element.previewId;
            state.dragData.element = payload.element;
            state.dragData.X = payload.ev.clientX;
            state.dragData.Y = payload.ev.clientY;
            state.dragData.type = "resize";
            state.dragData.direction = payload.direction;
        },
        [mutates.START_DRAG](state, payload) {
            state.currentElementIndex = payload.element.previewId;
            state.dragData.element = payload.element;
            state.dragData.X = payload.ev.clientX;
            state.dragData.Y = payload.ev.clientY;
            state.dragData.type = "drag";
            state.dragData.direction = null;
        },
        [mutates.STOP_DRAG](state) {
            if (state.dragData.element != null) {
                state.dragData.element = null;
                state.dragData.X = 0;
                state.dragData.Y = 0;
                state.dragData.type = "";
                state.dragData.direction = null;
            }
        },
        [mutates.HANDLE_DRAG](state, ev) {
            if (!state.dragData.element) return
            const deltaX = Math.round((ev.clientX - state.dragData.X) / (state.usedScale == "composition" ? state.previewScaleComposition : state.previewScale));
            const deltaY = Math.round((ev.clientY - state.dragData.Y) / (state.usedScale == "composition" ? state.previewScaleComposition : state.previewScale));
            if (Array.isArray(state.dragData.element)) {
                for (const el of state.dragData.element) {
                    if (state.dragData.type == "drag")
                        el.updatePosition(deltaX, deltaY);
                    else if (state.dragData.type == "resize")
                        el.updateSize(deltaX, deltaY, state.dragData.direction)
                }
            }
            else {
                if (state.dragData.type == "drag")
                    state.dragData.element.updatePosition(deltaX, deltaY);
                else if (state.dragData.type == "resize")
                    state.dragData.element.updateSize(deltaX, deltaY, state.dragData.direction)
            }
            state.dragData.X = ev.clientX;
            state.dragData.Y = ev.clientY;
        },
        [mutates.SET_SNAP_ENABLED](state, snapEnabled) {
            state.snapData.enabled = snapEnabled;
        },
        [mutates.SET_IS_DARK_MODE](state, isDarkMode) {
            state.isDarkMode = isDarkMode;
        },
        [mutates.UNDO](state) {
            if (state.historyIndex > 0) {
                state.historyIndex--;
                const h = state.history[state.historyIndex]
                state.currentPageIndex = h.pageIndex;
                state.currentElementIndex = h.currentElementIndex;
                if (h.data) {
                    state.pages[h.pageIndex].fromObject(JSON.parse(h.data));
                }
                state.compositions = h.compositions.map(el => composition.fromObject(JSON.parse(el)));
                if (h.compositionEditing) {
                    state.compositionEditing = composition.fromObject(JSON.parse(h.compositionEditing));
                }
            }
        },
        [mutates.REDO](state) {
            if (state.historyIndex < state.history.length - 1) {
                state.historyIndex++;
                const h = state.history[state.historyIndex];
                state.currentPageIndex = h.pageIndex;
                state.currentElementIndex = h.currentElementIndex;
                if (h.data) {
                    state.pages[h.pageIndex].dispose();
                    state.pages[h.pageIndex].fromObject(JSON.parse(h.data));
                }
                state.compositions = h.compositions.map(el => composition.fromObject(JSON.parse(el)));
                if (h.compositionEditing) {
                    state.compositionEditing = composition.fromObject(JSON.parse(h.compositionEditing));
                }
            }
        },
        [mutates.SET_CURRENT_ELEMENT_INDEX](state, element) {
            if (Array.isArray(element)) {
                if (element.length > 0) {
                    state.currentElementIndex = element[0].previewId;
                }
            }
            else {
                state.currentElementIndex = element.previewId;
            }
        },
        [mutates.SET_CURRENT_PAGE](state, pageIndex) {
            if (state.currentPageIndex != pageIndex) {
                state.currentPageIndex = pageIndex;
                state.currentElementIndex = null;
                state.dragData.element = null;
                state.dragData.type = "";
                state.dragData.direction = null;
                state.dragData.X = 0;
                state.dragData.Y = 0;
                state.pages[pageIndex].onShow();
            }
        },
        [mutates.SET_PAGE](state, page) {
            state.pages.push(page);
        },
        [mutates.UPDATE_PAGE](state, page) {
            const index = state.pages.findIndex(p => p.id === page.id);
            if (index !== -1) {
                state.pages[index] = page;
            }
        },
        [mutates.REMOVE_PAGE](state, pageId) {
            const index = state.pages.findIndex(p => p.id !== pageId);
            if (index !== -1) {
                state.pages.splice(index, 1);
            }
        },
        [mutates.SET_PAGES](state, pages) {
            state.pages = pages;
        },
        [mutates.SET_PAGE_ELEMENTS](state, pageId, elements) {
            const index = state.pages.findIndex(p => p.id === pageId);
            if (index !== -1) {
                state.pages[index].elements = elements;
            }
        },
        [mutates.SET_PAGE_ELEMENT](state, pageId, element) {
            const index = state.pages.findIndex(p => p.id === pageId);
            if (index !== -1) {
                state.pages[index].elements.push(element);
            }
        },
        [mutates.REMOVE_COMPOSITION](state, composition) {
            let index = state.compositions.findIndex(c => c.previewId == composition.previewId);
            if (index != -1) {
                state.compositions.splice(index, 1);
            }
            index = state.possibleCompositions.findIndex(c => c.previewId == composition.previewId);
            if (index != -1) {
                state.possibleCompositions.splice(index, 1);
            }
            document.dispatchEvent(state.eventCompositionRemove);
        },
        [mutates.REMOVE_COMPOSITION_ELEMENT](state, previewId) {
            state.compositionEditing.removeFromBuild(previewId);
        },
        [mutates.REMOVE_PAGE_ELEMENT](state, previewId) {
            if (state.currentPageIndex == null || state.pages[state.currentPageIndex] == null) {
                return null;
            }
            let pagesElements = state.pages[state.currentPageIndex]?.toIterable();
            if (pagesElements == null || pagesElements.length == 0) {
                return null;
            }
            for (const pe of pagesElements) {
                let found = pe.getParentFromPreviewId(previewId);
                if (found != null && typeof found == "object") {
                    if (found.property.type == "arrayInput") {
                        found.parent[found.property.name].splice(found.parent[found.property.name].findIndex(e => e.previewId === previewId), 1);
                    }
                    else {
                        found.parent[found.property.name] = null;
                    }
                    return null;
                }
                if (found != null && typeof found == "boolean" && found == true) {
                    //base element found, remove it
                    state.pages[state.currentPageIndex].removeBaseElement(previewId);
                    if (state.currentElementIndex == previewId) {
                        state.currentElementIndex = null;
                        state.dragData.element = null;
                        state.dragData.type = "";
                        state.dragData.direction = null;
                        state.dragData.X = 0;
                        state.dragData.Y = 0;
                    }
                    return null;
                }
            }
            return null;
        },
        [mutates.UPDATE_PROPERTY](state, payload) {
            if (payload.element) {
                payload.element[payload.property.name] = payload.value;
            }
        },
        [mutates.UPDATE_ORDER_PROPERTY](state, payload) {
            if (payload.element && payload.element.swapArrayElement) {
                payload.element.swapArrayElement(payload.index, payload.move);
            }
            else if (payload.element == undefined && payload.property) {
                state.pages[state.currentPageIndex].swapArrayElement(payload.property, payload.index, payload.move);
            }
        },
        [mutates.SET_RESSOURCES](state, ressources) {
            if (typeof ressources == "object") {
                let index = -1;
                if (Array.isArray(ressources)) {
                    for (const ressource of ressources) {
                        index = state.ressources.findIndex(r => r.id == ressource.id);
                        if (index != -1) {
                            state.ressources[index] = ressource;
                        }
                        else {
                            state.ressources.push(ressource);
                        }
                        if (ressource.type_ressource == "font") {
                            document.fonts.add(new FontFace(ressource.idSoft, `url(${ressource.url})`));
                        }
                    }
                }
                else {
                    index = state.ressources.findIndex(r => r.id == ressources.id);
                    if (index != -1) {
                        state.ressources[index] = ressources;
                    }
                    else {
                        state.ressources.push(ressources);
                    }
                    if (ressources.type_ressource == "font") {
                        document.fonts.add(new FontFace(ressources.idSoft, `url(${ressources.url})`));
                    }
                }
            }
            else {
                state.ressources = [];
            }
        },
        [mutates.REMOVE_RESSOURCE](state, idSoft) {
            state.ressources.splice(state.ressources.findIndex(r => r.idSoft == idSoft), 1);
        },
        [mutates.REMOVE_THEME](state, id) {
            state.themeList.splice(state.themeList.findIndex(t => t.idSoft == id), 1);
        }
    },
    actions: {
        [actions.DUPLICATE_THEME]({ commit, dispatch }, id) {
            return new Promise((resolve, reject) => {
                themeApi.duplicateTheme(id).then(response => {
                    if (response.data.success) {
                        themeApi.getTheme(response.data.theme.url_fichier).then(r => {
                            if (r.data) {
                                commit(mutates.SET_THEME_LIST, { ...response.data.theme, theme: r.data });
                                commit(mutates.ADD_TO_HISTORY);
                            }
                            resolve(r.data);
                        }).catch(error => {
                            reject(error);
                        });
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                        message: error.response?.data?.error || error.message,
                        type: "error"
                    }, { root: true });
                    reject(error);
                });
            });
        },
        [actions.EXPORT_FULL_THEME]({ commit, getters, dispatch }) {
            return new Promise((resolve, reject) => {
                try {
                    console.log(getters.themeBuild);
                    console.log(getters.themeName);
                    // Créer un lien de téléchargement direct avec nom personnalisé
                    const a = document.createElement('a');
                    a.href = getters.themeBuild;
                    a.download = getters.themeName + '.lth';
                    a.target = '_blank'; // Ouvrir dans un nouvel onglet si nécessaire

                    // Ajouter temporairement au DOM
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    resolve();
                } catch (error) {
                    dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                        message: 'Erreur lors du téléchargement du fichier',
                        type: "error"
                    }, { root: true });
                    reject(error);
                }
            });
        },
        [actions.DUPLICATE_COMPOSITION]({ commit }, comp) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('json_data', composition.fromObject(comp.toObject(true)).toJSON());
                if (composition.Name)
                  formData.append('nom', comp.Name + " (Copie)");
                if (composition.description)
                  formData.append('description', composition.description);
                userApi.uploadComposition(formData).then(response => {
                    if (response.data.success) {
                        compositionApi.getComposition(response.data.composition.url_fichier).then(response => {
                            if (response.data) {
                                comp = composition.fromObject(response.data);
                                commit(mutates.ADD_COMPOSITION, comp);
                                resolve(comp);
                            }
                        }).catch(error => {
                            console.error('Erreur lors de la récupération de la composition:', error);
                            reject(error);
                        });
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.REMOVE_RESSOURCE]({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                userApi.deleteRessource(payload.idSoft).then(response => {
                    if (response.data.success) {
                        if (payload.clear) {
                            commit(mutates.REMOVE_RESSOURCE, payload.idSoft);
                        }
                        dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                            message: response.data.message,
                            type: "success"
                        }, { root: true });
                        resolve(response.data);
                    }
                    else {
                        dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                            message: response.data.error || 'Erreur lors de la suppression',
                            type: "error"
                        }, { root: true });
                        reject(response.data.error);
                    }
                }).catch(error => {
                    dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                        message: error.response?.data?.error || error.message,
                        type: "error"
                    }, { root: true });
                    reject(error);
                });
            });
        },
        [actions.UPLOAD_RESSOURCE]({ commit, dispatch }, formData) {
            return new Promise((resolve, reject) => {
                userApi.uploadRessource(formData).then(response => {
                    if (response.data.success) {
                        dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                            message: response.data.message,
                            type: "success"
                        }, { root: true });
                        commit(mutates.SET_RESSOURCES, response.data.ressource);
                        dispatch(actions.SET_FONT_FAMILY).then(() => {
                            resolve(response.data);
                        }).catch(error => {
                            reject(error);
                        });
                    }
                    else {
                        dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                            message: response.data.error || 'Erreur lors de l\'upload',
                            type: "error"
                        }, { root: true });
                        reject(response.data.error);
                    }
                }).catch(error => {
                    dispatch(NAMESPACES.MESSAGE + '/addMessage', {
                        message: error.response?.data?.error || error.message,
                        type: "error"
                    }, { root: true });
                    reject(error);
                });
            });
        },
        [actions.SELECT_THEME]({ commit }, index) {
            commit(mutates.SELECT_THEME, index);
            commit(mutates.SET_ACTIVE_COMPOSITION_FROM_THEME);
        },
        [actions.SET_FONT_FAMILY]({ commit, getters }) {
            return new Promise((resolve, reject) => {
                let fontRessource = getters.ressourcesByType("font");
                for (const f of fontRessource) {
                    if (!f.fontLoaded) {
                        let font = new FontFace(f.name, `url(${f.url})`);
                        if (!document.fonts.has(font)) {
                            commit(mutates.LOAD_FONT, {font: font.load(), ressource: f});
                        }
                    }
                }
                Promise.all(getters.fontPromiseList).then(() => {
                    resolve();
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    commit(mutates.CLEAR_FONT_PROMISE_LIST);
                });
            });
        },
        [actions.REMOVE_COMPOSITION]({ commit }, composition) {
            return new Promise((resolve, reject) => {
                userApi.deleteComposition(composition.siteId).then(response => {
                    if (response.data.success) {
                        commit(mutates.REMOVE_COMPOSITION, composition);
                        resolve(response.data);
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.GET_COMPOSITIONS]({ commit }) {
            return new Promise((resolve, reject) => {
                userApi.getCompositions().then(response => {
                    if (response.data.success) {
                        let promiseList = []
                        for (const c of response.data.compositions) {
                            let promiseCallUrl = compositionApi.getComposition(c.url_fichier).then(response => {
                                if (response.data) {
                                    commit(mutates.ADD_COMPOSITION, composition.fromObject(response.data));
                                }
                            }).catch(error => {
                                console.error('Erreur lors de la récupération de la composition:', error);
                            });
                            promiseList.push(promiseCallUrl);
                        }
                        Promise.allSettled(promiseList).then((value) => {
                            resolve(value);
                        }).catch(error => {
                            reject(error);
                        });
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.UPLOAD_COMPOSITION]({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                userApi.uploadComposition(formData).then(response => {
                    if (response.data.success) {
                        if (getters.compositionEditing && getters.compositionEditing.siteId == null) {
                            commit(mutates.REMOVE_COMPOSITION, getters.compositionEditing);
                        }
                        compositionApi.getComposition(response.data.composition.url_fichier).then(response => {
                            if (response.data) {
                                commit(mutates.ADD_COMPOSITION, composition.fromObject(response.data));
                                resolve(response.data);
                            }
                        }).catch(error => {
                            console.error('Erreur lors de la récupération de la composition:', error);
                            reject(error);
                        });
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.GET_THEMES]({ commit }) {
            return new Promise((resolve, reject) => {
                themeApi.getThemes().then(response => {
                    if (response.data.success) {
                        let promiseList = []
                        for (const c of response.data.themes) {
                            let promiseCallUrl = themeApi.getTheme(c.url_fichier).then(r => {
                                if (r.data) {
                                    commit(mutates.SET_THEME_LIST, { ...c, theme: r.data });
                                }
                            }).catch(error => {
                                console.error('Erreur lors de la récupération du thème:', error);
                            });
                            promiseList.push(promiseCallUrl);
                        }
                        Promise.allSettled(promiseList).then((value) => {
                            commit(mutates.ADD_TO_HISTORY);
                            resolve(value);
                        }).catch(error => {
                            reject(error);
                        });
                    }
                    else {
                        reject(response.data.error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.UPLOAD_THEME]({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                formData.append('build_data', JSON.stringify(getters.exportTheme));
                userApi.uploadTheme(formData).then(response => {
                    themeApi.getTheme(response.data.theme.url_fichier).then(r => {
                        if (r.data) {
                            commit(mutates.SET_THEME_ID, response.data.theme.id);
                            commit(mutates.SET_THEME_NAME, response.data.theme.nom);
                            commit(mutates.SET_THEME_DESCRIPTION, response.data.theme.description);
                            commit(mutates.SET_THEME_THUMBNAIL, response.data.theme.fichier_thumbnail?.id);
                            commit(mutates.SET_THEME_LIST, { ...response.data.theme, theme: r.data });
                        }
                        commit(mutates.SET_THEME_MODIFICATION_NOT_SAVED, false);
                    }).catch(error => {
                        console.error('Erreur lors de la récupération du thème:', error, response.data);
                    });
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.DELETE_THEME]({ commit }, id) {
            return new Promise((resolve, reject) => {
                themeApi.deleteTheme(id).then(response => {
                    commit(mutates.REMOVE_THEME, id);
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.GET_RESSOURCES]({ commit }) {
            return new Promise((resolve, reject) => {
                userApi.getRessources().then(response => {
                    if (response.data.success) {
                        commit(mutates.SET_RESSOURCES, response.data.ressources);
                    }
                    else {
                        reject(response.data.error);
                    }
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        [actions.CREATE_COMPOSITION_AND_SET_EDITING]({ commit }) {
            const comp = composition.fromObject();
            commit(mutates.ADD_COMPOSITION, comp);
            commit(mutates.SET_COMPOSITION_EDITING, comp);
            commit(mutates.ADD_TO_HISTORY);
            return comp;
        },
        [actions.CREATE_DEFAULT_THEME]({ commit }) {
            commit(mutates.CREATE_DEFAULT_THEME);
            commit(mutates.ADD_TO_HISTORY);
        },
        [actions.SET_CURRENT_PAGE]({commit}, payload) {
            commit(mutates.SET_CURRENT_PAGE, payload);
            commit(mutates.ADD_TO_HISTORY);
        },
        [actions.ADD_COMPOSITION_ELEMENT]({ commit }, payload) {
            commit(mutates.ADD_COMPOSITION_ELEMENT, payload);
            commit(mutates.ADD_TO_HISTORY);
        },
        [actions.ADD_ELEMENT]({ commit }, payload) {
            commit(mutates.ADD_ELEMENT, payload);
            commit(mutates.ADD_TO_HISTORY);
            commit(mutates.SET_THEME_MODIFICATION_NOT_SAVED, true);
        },
        [actions.REMOVE_COMPOSITION_ELEMENT]({ commit }, payload) {
            commit(mutates.REMOVE_COMPOSITION_ELEMENT, payload);
            commit(mutates.ADD_TO_HISTORY);
        },
        [actions.REMOVE_PAGE_ELEMENT]({ commit }, payload) {
            commit(mutates.REMOVE_PAGE_ELEMENT, payload);
            commit(mutates.ADD_TO_HISTORY);
            commit(mutates.SET_THEME_MODIFICATION_NOT_SAVED, true);
        },
        [actions.UPDATE_ORDER_PROPERTY]({ commit }, payload) {
            commit(mutates.UPDATE_ORDER_PROPERTY, payload);
            commit(mutates.ADD_TO_HISTORY);
            commit(mutates.SET_THEME_MODIFICATION_NOT_SAVED, true);
        },
        [actions.UPDATE_PROPERTY]({commit}, payload) {
            commit(mutates.UPDATE_PROPERTY, payload);
            commit(mutates.ADD_TO_HISTORY, true);
            commit(mutates.SET_THEME_MODIFICATION_NOT_SAVED, true);
        },
        [actions.STOP_DRAG]({ commit, getters }) {
            if (getters.dragData.element != null) {
                commit(mutates.STOP_DRAG);
                commit(mutates.ADD_TO_HISTORY);
            }
        },
        [actions.SET_SELECTED_COMPOSITION_ELEMENT]({commit, getters}, elementIndex) {
            if (elementIndex) {
                let element = getters.getCompositionElementById(elementIndex);
                if (element) {
                    commit(mutates.SET_CURRENT_ELEMENT_INDEX, element);
                }
            }
        },
        [actions.SET_SELECTED_ELEMENT]({commit, getters}, elementIndex) {
            if (elementIndex) {
                let element = getters.getBaseElementById(elementIndex);
                if (element) {
                    commit(mutates.SET_CURRENT_ELEMENT_INDEX, element);
                }
            }
            else {
                console.error('Element index is not provided');
                return false;
            }
        },
        [actions.START_RESIZE_COMPOSITION]({commit, getters}, payload) {
            if (payload.el && payload.ev) {
                let element = getters.getCompositionElementById(payload.el);
                if (element) {
                    commit(mutates.START_RESIZE, {element: element, ev: payload.ev, direction: payload.direction});
                }
            }
            else {
                console.error('Element or event is not provided');
            }
            return false;
        },
        [actions.START_RESIZE]({ commit, getters }, payload) {
            if (payload.el && payload.ev) {
                let element = getters.getBaseElementById(payload.el);
                if (element) {
                    commit(mutates.START_RESIZE, { element: element, ev: payload.ev, direction: payload.direction });
                    return true;
                }
            }
            else {
                console.error('Element or event is not provided');
            }
            return false;
        },
        [actions.START_DRAG_COMPOSITION]({commit, getters}, payload) {
            if (payload.el && payload.ev) {
                let element = getters.getCompositionElementById(payload.el);
                if (element) {
                    commit(mutates.START_DRAG, {element: element, ev: payload.ev});
                    return true;
                }
            }
            else {
                console.error('Element or event is not provided');
            }
            return false;
        },
        [actions.START_DRAG]({commit, getters}, payload) {
            if (payload.el && payload.ev) {
                let element = getters.getBaseElementById(payload.el);
                if (element) {
                    commit(mutates.START_DRAG, {element: element, ev: payload.ev});
                    return true;
                }
            }
            else {
                console.error('Element or event is not provided');
            }
            return false;
        },
    },
}
